import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AntModal from 'antd/lib/modal';
import './style';

const propTypes = {
  ...AntModal.propTypes,
  /**
   * Remove the modal body padding
   */
  noPadding: PropTypes.bool,
  /**
   * Make the modal has blue header
   */
  primary: PropTypes.bool,
  /**
   * Add an icon in the middle of the modal
   */
  icon: PropTypes.node,
  /**
   * Align the modal, current support vertical center
   */
  align: PropTypes.oneOf(['middle', null]),
  wrapClassName: PropTypes.string,
};

const defaultProps = {
  ...AntModal.defaultProps,
  noPadding: false,
  primary: false,
  icon: null,
  align: null,
};

function Modal({
  noPadding, primary, icon, className, wrapClassName, align, children, ...rest
}) {
  const bodyStyle = noPadding ? { padding: 0 } : null;
  const computedClassName = classNames(
    'bsa-modal',
    { 'bsa-modal--primary': primary },
    className,
  );
  const computedWrapClassName = classNames({
    'bsa-vertical-center-modal': align === 'middle',
  }, wrapClassName);
  if (!icon) {
    return (
      <AntModal
        className={computedClassName}
        wrapClassName={computedWrapClassName}
        bodyStyle={bodyStyle}
        {...rest}
      >
        {children}
      </AntModal>
    );
  }
  return (
    <AntModal
      className={computedClassName}
      wrapClassName={computedWrapClassName}
      {...rest}
    >
      <div className="modal-icon mt-2 mb-1 text-center">{icon}</div>
      <div className="text-center">{children}</div>
    </AntModal>
  );
}

Modal.defaultProps = defaultProps;
Modal.propTypes = propTypes;
Modal.ModalFuncProps = AntModal.ModalFuncProps;
Modal.contextTypes = AntModal.contextTypes;
Modal.error = AntModal.error;
Modal.warning = AntModal.warning;
Modal.success = AntModal.success;
Modal.info = AntModal.info;
Modal.confirm = AntModal.confirm;
export default Modal;
